const ROLE_ADMINISTRATOR = 'beststart.scorecard.admin';
const ROLE_SUPER_ADMINISTRATOR = 'beststart.scorecard.superadmin';
const ROLE_READONLY = 'beststart.scorecard.readonly';
const ROLE_CENTRE_MANAGER = 'beststart.scorecard.centremanager';
const ROLE_MANAGER = 'beststart.scorecard.manager';

const ALL_ROLES = [
    ROLE_ADMINISTRATOR,
    ROLE_SUPER_ADMINISTRATOR,
    ROLE_READONLY,
    ROLE_CENTRE_MANAGER,
    ROLE_MANAGER,
];

const ADMINS = [
    ROLE_ADMINISTRATOR,
    ROLE_SUPER_ADMINISTRATOR,
    ROLE_MANAGER,
];

const SUPPORT = [
    ...ADMINS,
    ROLE_READONLY,
];

/**
 * Map an impersonated employee's role/title string (e.g. "CentreManager",
 * "AreaManager", "RegionalManager", or a comma-joined combination such as
 * "AreaManager,RegionalManager") into the application role identifiers used
 * by `auth.isInAnyRole(...)`-style checks.
 *
 * - Centre managers map to ROLE_CENTRE_MANAGER.
 * - Area managers and Regional managers map to ROLE_MANAGER (so the My Staff
 *   section appears for them while impersonated).
 */
function getRolesForImpersonatedEmployee(employee) {
    const raw = (employee?.role ?? '').toString().toLowerCase();
    if (!raw) return [];
    const result = new Set();
    if (raw.includes('centremanager') || raw.includes('centre manager')) {
        result.add(ROLE_CENTRE_MANAGER);
    }
    if (
        raw.includes('areamanager') || raw.includes('area manager') ||
        raw.includes('regionalmanager') || raw.includes('regional manager')
    ) {
        result.add(ROLE_MANAGER);
    }
    return Array.from(result);
}

const roles = {
    ROLE_SUPER_ADMINISTRATOR,
    ROLE_ADMINISTRATOR,
    ROLE_READONLY,
    ROLE_CENTRE_MANAGER,
    ROLE_MANAGER,
    SUPPORT,
    ALL_ROLES,
    ADMINS,
    getRolesForImpersonatedEmployee,
};

export { getRolesForImpersonatedEmployee };
export default roles;
